//@ts-check
import {Dropdown, Modal} from '@/components-v2'
import {useProductCombo} from '@/context/ProductCombo/ProductComboContext'
import {BUSINESS_GROUP_OPTIONS} from '@/utils/constants/productComboConstants'
import {useState} from 'react'

export const SnacksAndBevarages = () => {
  const {productCombo, updateProductCombo} = useProductCombo()
  const [showConfirmationModal, setShowConfirmationModal] = useState(false)
  const [pendingBusinessGroup, setPendingBusinessGroup] = useState(null)

  const currentOption = productCombo?.businessGroup
    ? BUSINESS_GROUP_OPTIONS.find(opt => opt.id === productCombo.businessGroup)
    : null

  const handleUpdateValue = values => {
    const selectedValue = values?.[0]
    if (!selectedValue) return

    if (productCombo?.comboSkus?.length && productCombo?.businessGroup !== selectedValue.id) {
      setPendingBusinessGroup(selectedValue.id)
      setShowConfirmationModal(true)
    } else {
      updateProductCombo({
        businessGroup: selectedValue.id,
        comboSkus: [],
        displayCategories: [],
        displayCategoryIds: [],
      })
    }
  }

  const handleConfirm = () => {
    updateProductCombo({
      businessGroup: pendingBusinessGroup || '',
      comboSkus: [],
      displayCategories: [],
      displayCategoryIds: [],
    })
    setShowConfirmationModal(false)
    setPendingBusinessGroup(null)
  }

  const handleCancel = () => {
    setShowConfirmationModal(false)
    setPendingBusinessGroup(null)
  }

  return (
    <>
      <Dropdown
        label="Snacks & Beverages*"
        childList={BUSINESS_GROUP_OPTIONS}
        setSelectedValue={handleUpdateValue}
        selectedValue={currentOption ? [currentOption] : []}
        selection="single"
        menuPosition="top-right"
      />
      <Modal
        showModal={showConfirmationModal}
        onCloseModal={handleCancel}
        showTertiaryButton={true}
        tertiaryButtonProps={{text: 'Cancel', onClick: handleCancel}}
        showPrimaryButton={true}
        primaryButtonProps={{text: 'Continue', onClick: handleConfirm}}
        title="Changing the Snacks & Beverages selection will reset the Product List"
        text="If you change the Snacks & Beverages selection, the current product list in this combo will be cleared. Do you want to continue?"
        hideCloseButton={true}
      />
    </>
  )
}
